import NextLink from 'next/link';

const ZONE = '/event';

/**
 * Drop-in replacement for `next/link` in pages copied from the monolith.
 *
 * Those pages link with monolith-absolute paths. `/event/...` targets stay in
 * this zone, so the prefix is stripped and `basePath` adds it back. Any other
 * path belongs to another zone and renders a plain anchor, because `next/link`
 * would prefix it with `/event`.
 */
function toZonePath( value ){
	if( typeof value !== 'string' ){ return null; }
	if( value === ZONE ){ return '/'; }
	return value.startsWith( ZONE + '/' ) || value.startsWith( ZONE + '?' ) ? value.slice( ZONE.length ) : null;
}

export default function Link({ href, as, prefetch, replace, scroll, shallow, passHref, legacyBehavior, ...rest }){
	const target = as ?? href;
	const zoneHref = toZonePath( href );
	const zoneAs = as === undefined ? undefined : toZonePath( as );

	if( typeof href !== 'string' || ( zoneHref !== null && ( as === undefined || zoneAs !== null ) ) ){
		return <NextLink href={zoneHref ?? href} as={zoneAs ?? undefined} prefetch={prefetch} replace={replace} scroll={scroll} shallow={shallow} {...rest} />;
	}

	return <a href={target} {...rest} />;
}
